import React from 'react';

const DashboardPage: React.FC = () => {
    return <div>Dashboard Page</div>;
};

export default DashboardPage;
